import { render, staticRenderFns } from "./CoachFollowFull.vue?vue&type=template&id=2ca812a2&"
import script from "./CoachFollowFull.vue?vue&type=script&lang=js&"
export * from "./CoachFollowFull.vue?vue&type=script&lang=js&"
import style0 from "./CoachFollowFull.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CoachFollowFull.vue"
export default component.exports